import ahoy from 'ahoy.js';
import { useInViewEffect } from 'react-hook-inview';

import { preventDefault } from './shared/events';
import ListingCard from './ListingCard';

export default function TrackableListingCard({
  listing, contributor, adopter, favorite, noToggler, userType, userID, trackEvent
}) {
  const {id, status, days_remaining} = listing;
  const active = status == 'published' && days_remaining > 0;
  const viewable = active || contributor;

  const path = window.location.pathname + window.location.search;
  const trackClick = () => {
    if (trackEvent) {
      ahoy.track(trackEvent, {listing_id: id, user_type: userType, user_id: userID, path});
    }
  };
  const trackImpression = () => {
    if (active && !contributor) {
      ahoy.track("LISTING_IMPRESSION", {listing_id: id, user_type: userType, user_id: userID, path});
    }
  };
  const ref = useInViewEffect(([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      _.delay(trackImpression, _.random(1, 100));
    }
  });

  return (
    <ListingCard ref={ref}
      {...{listing, active, viewable, contributor, adopter, favorite, noToggler, userType, userID}}
      onClick={viewable ? trackClick : preventDefault()}/>
  );
}
